import React from 'react';
import { Typography, withStyles } from '@material-ui/core';
import submitDocIcon from '~/images/icons/Submit_Returns2.svg';
import totalTaxIcon from '~/images/icons/Icon_Tax_Return.svg';
import bankTaxIcon from '~images/icons/Bank_App_Icon.svg';

import { SPINNER_DIALOGS } from '~/app/constants.js';
import ButtonSpinner from '#/Common/ButtonSpinner.jsx';

const styles = theme => ({
  count: {
    ...theme.metricTile.count,
  },
  overviewCount: {
    ...theme.metricTile.overviewCount,
  },
  label: {
    ...theme.metricTile.label,
  },
  widgetLabel: {
    ...theme.metricTile.widgetLabel,
  },
  subLabel: {
    ...theme.metricTile.subLabel,
  },
  summary: {
    ...theme.metricTile.summaryContent,
  },
  submitIconContainer: {
    ...theme.metricTile.submitIconContainer,
  },
  totalTaxIconContainer: {
    ...theme.metricTile.totalTaxIconContainer,
  },
  genericIconContainer: {
    ...theme.metricTile.genericIconContainer,
  },
  bankIconContainer: {
    ...theme.metricTile.bankIconContainer,
  },
  textContainer: {
    ...theme.metricTile.textContainer,
  },
});

const MetricTile = ({ classes, variant, card }) => {
  const renderCount = () => {
    if (card.loading) {
      return (
        <ButtonSpinner
          id="btnOverviewCardLoading"
          isLoading
          buttonText=""
          style={{ color: '#ffffff' }}
          spinnerColor="#9dd1ff"
        />
      );
    }

    if (card.error) {
      return '--';
    }

    return card.count;
  };

  const renderLabel = () => {
    if (card.loading) {
      return 'Loading...';
    }
    if (card.error) {
      return `Error loading ${card.title}`;
    }
    return card.sublabel;
  };

  if (variant === 'totalTax') {
    return (
      <div>
        <div className={classes.summary}>
          <div className={classes.genericIconContainer}>
            <img src={totalTaxIcon} />
          </div>

          <div className={classes.textContainer}>
            <Typography className={classes.overviewCount}>{renderCount()}</Typography>
            <Typography className={classes.label}>{card.title}</Typography>
            <Typography className={classes.subLabel}>{renderLabel()}</Typography>
          </div>
        </div>
      </div>
    );
  }
  if (variant === 'submittedReturns') {
    return (
      <div>
        <div className={classes.summary}>
          <div className={classes.genericIconContainer}>
            <img src={submitDocIcon} />
          </div>
          <div className={classes.textContainer}>
            <Typography className={classes.overviewCount}>{renderCount()}</Typography>
            <Typography className={classes.label}>{card.title}</Typography>
            <Typography className={classes.subLabel}>{renderLabel()}</Typography>
          </div>
        </div>
      </div>
    );
  }
  if (variant === 'bankApps') {
    return (
      <div>
        <div className={classes.summary}>
          <div className={classes.genericIconContainer}>
            <img src={bankTaxIcon} />
          </div>
          <div className={classes.textContainer}>
            <Typography className={classes.overviewCount}>{renderCount()}</Typography>
            <Typography className={classes.label}>{card.title}</Typography>
            <Typography className={classes.subLabel}>{renderLabel()}</Typography>
          </div>
        </div>
      </div>
    );
  }
  // Generic for now. Revisit as adding Rows
  if (card.loading) {
    return (
      <div>
        <ButtonSpinner
          id="btnOverviewCardLoading"
          isLoading={card.loading}
          buttonText={SPINNER_DIALOGS.LOADING}
          style={{ color: '#ffffff' }}
          spinnerColor="#9dd1ff"
        ></ButtonSpinner>
      </div>
    );
  }
  if (card.error) {
    return (
      <>
        <Typography className={classes.count}>{renderCount()}</Typography>
        <Typography className={classes.widgetLabel}>{renderLabel()}</Typography>
      </>
    );
  }
  return (
    <>
      <Typography className={classes.count}>{card.count}</Typography>
      <Typography className={classes.widgetLabel}>{card.title}</Typography>
    </>
  );
};

export default withStyles(styles)(MetricTile);
